import { Component, Input, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ParentChildRelationship, PropertiesService } from '@app/shared/services/properties/properties.service';
import { SegmentEvent, SegmentIoService } from '@app/shared/services/segmentIo/segment-io.service';
import { DialogParentChildRemoveRelationshipConfirm } from '../dialog-parent-child-remove-relationship-confirm/dialog-parent-child-remove-relationship-confirm.component';

@Component({
  standalone: false,
  selector: 'sbnb-parent-child-relationship-visualiser',
  templateUrl: './parent-child-relationship-visualiser.component.html',
  styleUrls: ['./parent-child-relationship-visualiser.component.scss'],
})
export class ParentChildRelationshipVisualiser implements OnInit {
  @Input() propertyId!: number;

  loading = false;
  deleting = false;

  parentChildConfig: ParentChildRelationship | null = null;

  constructor(
    private propertiesService: PropertiesService,
    private dialog: MatDialog,
    private segmentIoService: SegmentIoService
  ) { }

  ngOnInit() {
    this.loading = true;

    this.propertiesService.getParentChildRelationship(this.propertyId).subscribe((res) => {
      this.loading = false;
      this.parentChildConfig = res;
    });
  }

  removeRelationship() {
    this.segmentIoService.track(SegmentEvent.ParentChildRemovalStarted, {});

    const dialog = this.dialog.open(DialogParentChildRemoveRelationshipConfirm, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      disableClose: true,
      autoFocus: false,
      data: {},
    });

    dialog.afterClosed().subscribe((result) => {
      if (!result) {
        return;
      }

      this.deleting = true;

      const parentId = this.parentChildConfig.properties.find((prop) => prop.type === 'parent')?.id;

      if (!parentId) {
        console.error('No parent found for property');
        return;
      }

      this.propertiesService.removeParentChildRelationship(parentId).subscribe(
        (res) => {
          this.segmentIoService.track(SegmentEvent.ParentChildRemovalCompleted, { parentId });
          this.deleting = false;
          (location as any).reload();
        },
        (err) => {
          alert('Error removing relationship');
          this.deleting = false;
        }
      );
    });
  }
}
